import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";
import Footer from "./components/Footer";
import Menu from "./components/Menu";

import { useAuth } from "@/features/Auth";
import WorkspaceSwitcher from "@/features/Workspaces/WorkspaceSwitcher";

export default function AppSidebar() {
  const { user } = useAuth();
  useSidebar();

  if (!user) return null;

  return (
    <Sidebar collapsible="offcanvas">
      <SidebarHeader className="relative pt-1 pb-0">
        <div className="flex items-center px-2 py-1 transition-all justify-center">
          <WorkspaceSwitcher />
        </div>
      </SidebarHeader>
      <SidebarContent
        className="px-0 py-2 overflow-y-auto no-scrollbar"
        data-sidebar-scroll
      >
        <Menu
          userWorkooks={user.workbooks}
          isSidebarClose={false /* shadcn collapses itself */}
          userTables={user.tables}
          sectionTranscription={user.section_transcription}
          sectionRouteOverrides={user.section_route_overrides}
          hideMenuTitles={true}
        />
      </SidebarContent>
      <SidebarFooter className="border-t border-slate-200">
        <Footer />
      </SidebarFooter>
    </Sidebar>
  );
}
